import * as yup from "yup";
import { validationSchemas } from "./data";
export const currencySchema = yup.object().shape({
  currency: validationSchemas.name,
  country: validationSchemas.name,
});
